import request from 'superagent';

import { Methods, IApiParams } from './interfaces';

import {
  ICheckUserRegisterReq,
  IGetUsersForLessonsTableReq,
  IGetUsersForLessonsTableRes,
  IUpdateTeacherCommentReq,
  ICheckUserRegisterRes,
} from './models';

const { GET, POST, PATCH } = Methods;

export const api = async <T, R>({
  route,
  payload,
  method,
}: IApiParams<T>): Promise<R> => {
  switch (method) {
    case POST:
      return (await request(method, route).send({ ...payload })).body;
    case PATCH:
      return (await request.patch(route).send({ ...payload })).body;
    case GET:
    default:
      return (await request(method, route).query({ ...payload })).body;
  }
};

// TODO - переписать методы выше на использование метода api()

export const getUsersForLessonsTable = (payload: IGetUsersForLessonsTableReq) =>
  api<IGetUsersForLessonsTableReq, IGetUsersForLessonsTableRes>({
    method: GET,
    route: '/user/all_for_lessons',
    payload,
  });

export const updateTeacherComment = (payload: IUpdateTeacherCommentReq) =>
  api<IUpdateTeacherCommentReq, null>({
    method: POST,
    route: '/lesson/updateComment',
    payload,
  });

export const checkUserRegister = (payload: ICheckUserRegisterReq) =>
  api<ICheckUserRegisterReq, ICheckUserRegisterRes>({
    method: GET,
    route: '/user/check_register',
    payload,
  });

export * from './lesson';
export * from './user';
export * from './salary';
export * from './payment';
export * from './project';
export * from './chatgpt';
